// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3Wk6l","bigColWidth":"Table_bigColWidth__qLCQf","biggerColWidth":"Table_biggerColWidth__cKvTE","row":"Table_row__MDudB","col":"Table_col__RCriJ"};